import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendAnalystViewSampleWithInstanceAndSpec,
	FrontendAdminViewSampleWithInstanceAndSpec,
} from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { FrontendContentPage } from "node-library/dist/constants";
import AdminViewInstanceRow from "./adminViewInstanceRow";

interface Props {
	instances: Array<FrontendAdminViewSampleWithInstanceAndSpec>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;

	navigateToInstanceDetailsPage: (
		instanceId: string,
		fromPage: FrontendContentPage
	) => void;

	navigateToOrderDetailsPage: (
		orderID: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AdminViewInstancesTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		instances,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		user,
		navigateToInstanceDetailsPage,
		navigateToOrderDetailsPage,
	} = props;

	const headerItems = [
		{
			title: translation("Instances"),
		},
		{
			title: translation("Order"),
		},
		{
			title: translation("Client"),
		},

		{
			title: translation("DueDate"),
		},
		{
			title: translation("Status"),
		},
		{
			title: translation("Action"),
		},
	];

	const instanceRows: Array<React.ReactNode> = instances
		? instances.map(
				(
					instance: FrontendAdminViewSampleWithInstanceAndSpec,
					index: number
				) => {
					return (
						<AdminViewInstanceRow
							key={instance.sampleInstanceId}
							instance={instance}
							user={props.user}
							goToViewInstanceDetails={() => {
								navigateToInstanceDetailsPage(
									instance.sampleInstanceId,
									FrontendContentPage.INSTANCE_PAGE
								);
							}}
							goToViewOrderDetails={() => {
								navigateToOrderDetailsPage(
									instance.orderId,
									FrontendContentPage.INSTANCE_PAGE
								);
							}}
						/>
					);
				}
		  )
		: [];

	const headerRowItems: React.ReactNode = headerItems.map((item) => {
		return (
			<div key={item.title} style={{ display: "flex", gap: "10px" }}>
				<Divider orientation="vertical" flexItem></Divider>
				<div
					className="typography-body-01"
					style={{
						color: NeutralColor.NEUTRAL_GREY_500,
						display: "flex",
						alignItems: "center",
						gap: "5px",
					}}
				>
					{item.title}
					{/* {item.sortColumnBy && (
						<SortArrowIcon
							sortOrder={sortOrder}
							notInUse={sortBy !== item.sortColumnBy}
						/>
					)} */}
				</div>
			</div>
		);
	});

	const instanceRowContainer: React.ReactNode = (
		<Card className="common-card card-medium-padding">{instanceRows}</Card>
	);

	return (
		<div>
			<div className=" instance-list-view-row instance-list-view-header">
				{headerRowItems}
			</div>
			{instanceRowContainer}
		</div>
	);
}
